import { Component, OnInit } from '@angular/core';
import { ProcessoService } from '../../processo/processo.service';
import { IdsProcessamento } from '../../models/ids-processamento.model';
import { ProcessamentoSituacao } from '../../models/processamento-situacao.enum';
import { RespostaProcessamento } from '../../mensagem-controle/resposta-processamento.model';

@Component({
  selector: 'app-manutencao-sincronizar-processos-associacoes',
  templateUrl: './manutencao-sincronizar-processos-associacoes.component.html',
  styleUrls: ['./manutencao-sincronizar-processos-associacoes.component.css'],
})
export class ManutencaoSincronizarProcessosAssociacoesComponent implements OnInit {
  public opcaoSelecionada: any;
  public opcoesSincronizacao = [
    { label: 'Documentos', value: 'Documentos', icon: 'pi-file' },
    { label: 'Partes', value: 'Partes', icon: 'pi-users' },
    { label: 'Metadados', value: 'Metadados', icon: 'pi-book' },
    { label: 'Movimentos', value: 'Movimentos', icon: 'pi-chart-line' },
  ];
  public sincronizar = false;
  public ids: any;
  public idsProcessamento: IdsProcessamento[];

  constructor(private processoService: ProcessoService) {}

  ngOnInit(): void {}

  public sincronizarProcessosAssociacoes() {
    this.sincronizar = true;
    const idsArray = this.ids.split(',').map((id) => id.trim());
    const methodName = `sincronizar${this.opcaoSelecionada}`;

    this.sincronizarOutrasSincronizacoes(idsArray, methodName);
  }

  private sincronizarOutrasSincronizacoes(idsArray: string[], methodName: string) {
    this.idsProcessamento = idsArray.map((origemId) => new IdsProcessamento(undefined, origemId));

    const promessas = idsArray.map((origemId, index) => {
      this.idsProcessamento[index].situacao = ProcessamentoSituacao.EM_EXECUCAO;

      this.processoService[methodName](origemId)
        .then(() => {
          const idProcessamento = this.idsProcessamento[index];
          if (idProcessamento) {
            idProcessamento.resultado = RespostaProcessamento.PROCESSADO;
            idProcessamento.situacao = ProcessamentoSituacao.EXECUTADO;
          }
        })
        .catch((resposta) => {
          const idProcessamento = this.idsProcessamento[index];
          if (idProcessamento) {
            idProcessamento.resultado = RespostaProcessamento.FALHA;
            idProcessamento.situacao = ProcessamentoSituacao.EXECUTADO;
            idProcessamento.mensagemErro = resposta.error;
          }
        });
    });

    Promise.all(promessas);
  }
}
